/**
 * Genera un ID único corto para identificar compras
 * Formato: 4 caracteres alfanuméricos (ej: ak1p, x9m2)
 * @returns {string} ID único de compra
 */
export const generatePaymentId = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  
  for (let i = 0; i < 4; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return id;
};



